import React, { useMemo } from 'react';
import MetricsUserCompositionTrendsCo from '../MetricsUserCompositionTrendsCo';

const MetricsBreakDownContext = (props: any) => {
  const { config, data, changeData, segmentValue: propsSegmentValue } = props || {};
  const componentData = (data as any) || {};
  const { metricsInfo, segmentValue: dataSegmentValue } = componentData;

  // 获取当前的 segmentValue，优先使用 props 传入的
  const currentSegmentValue = propsSegmentValue || dataSegmentValue;

  const {
    metricEnName,
    metricCnName,
    formatRule,
    changeFormatRule,
    shareFormatRule,
    multiMetrics,
    multiMetricsMap,
    segmentDataKey,
    ...resetConfig
  } = config || {};

  // 根据 segmentValue 动态获取 multiMetrics
  const resolvedMultiMetrics = useMemo(() => {
    // 如果配置了 multiMetricsMap，根据当前 segment 获取对应的 multiMetrics
    if (multiMetricsMap && currentSegmentValue) {
      const mappedMetrics = multiMetricsMap[currentSegmentValue];

      // 如果是 'dynamic' 字符串或 { type: 'dynamic', ... } 对象，表示从数据中动态生成
      const isDynamicConfig = mappedMetrics === 'dynamic' ||
        (typeof mappedMetrics === 'object' && mappedMetrics?.type === 'dynamic');

      if (isDynamicConfig) {
        // 从 componentData?.data?.data 中提取所有的 metrics keys
        const responseData = componentData?.data?.data;
        if (responseData && Array.isArray(responseData) && responseData.length > 0) {
          const firstItem = responseData[0];
          if (firstItem?.metrics) {
            // 获取动态配置
            const dynamicConfig = typeof mappedMetrics === 'object' ? mappedMetrics : {};
            const defaultFormatter = dynamicConfig.formatter;
            const defaultYAxisFormatter = dynamicConfig.yAxisFormatter;

            return Object.keys(firstItem.metrics).map((key) => ({
              key,
              // 优先使用配置的 formatter，否则使用 metricsInfo 中该 key 对应的 formatter
              formatter: defaultFormatter || `{{metricsInfo.${key}.formatter}}`,
              // 添加 yAxisFormatter 支持
              ...(defaultYAxisFormatter ? { yAxisFormatter: defaultYAxisFormatter } : {}),
              // 支持其他配置项
              ...(dynamicConfig.itemConfig || {}),
            }));
          }
        }
        return [];
      }
      return mappedMetrics || [];
    }
    // 否则使用原来的 multiMetrics
    return multiMetrics;
  }, [multiMetricsMap, multiMetrics, currentSegmentValue, componentData?.data?.data]);

  return (
    <MetricsUserCompositionTrendsCo
      config={{
        ...config,
        metricEnName,
        metricCnName,
        formatRule,
        changeFormatRule,
        shareFormatRule,
        multiMetrics: resolvedMultiMetrics,
        segmentDataKey,
        ...resetConfig
      }}
      metricsData={componentData?.data || {}}
      metricsInfo={metricsInfo}
      changeData={changeData}
      segmentDataKey={segmentDataKey}
      currentSegmentValue={currentSegmentValue}
    />
  );
};

export default MetricsBreakDownContext;